import React, { useEffect, useState } from 'react';
import { isNumber } from "underscore";
import Constants from 'src/helper/Constants';
import { useSystem } from "src/hooks/system";

const PlusMinusInputWithDebounceRFQ = (props) => {
    const { force_default_quantity, disable_validation_check, QtyMin, QtyMult } = props;
    const [tempQuantity, setTempQuantity] = useState(false);
    const { QuantityAction: { Minus, Plus } } = Constants;
    const [,{ get_quantity_format }] = useSystem();
    const setQuantityWithAction = async (action) => {
        async function fetchHere() {
            let QtyMultHere = QtyMult;
            let q = 0;
            if (action === Minus) {
                q = tempQuantity - QtyMultHere
            }
            if (action === Plus) {
                q = tempQuantity + QtyMultHere
            }
            if (q < 1) {
                q = 0;
            }

            q = q <= QtyMin ? QtyMin : q;

            if (q > 0) {
                await manageTempQuantity(q);
            }
        }

        fetchHere()
    };
    useEffect(() => {
        setTempQuantity(QtyMin)
    }, [QtyMin]);

    useEffect(() => {
        if (force_default_quantity) {
            setTempQuantity(force_default_quantity);
        }
    }, [force_default_quantity]);

    const manageTempQuantity = (valueIn) => {
        valueIn = parseInt(valueIn);
        if (isNaN(valueIn)) {
            valueIn = 0;
        }
        setTempQuantity(valueIn);
        if (valueIn !== false) {
            if (props.onChange) {
                let d = validateBeforeSendToMainCheckFailing(valueIn);
                if (disable_validation_check) {
                    props.onChange(d, valueIn)
                    return;
                }

            }
        }
    }

    const validateBeforeSendToMainCheckFailing = (valueIn) => {
        if (QtyMin && valueIn < QtyMin) {
            return "Quantity entered should satisfy the min/mult rule";
        }
        if (QtyMult && valueIn % QtyMult !== 0) {
            return "Invalid Quantity";
        }
        return "";
    };

   

    return (
        <>
            <div className="quantity w-auto clearfix ">
                <div className="quantity-picker">
                    <div className="bs5 input-group flex-nowrap border-0">
                        <span className="bs5 input-group-prepend flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction(Minus);
                                }}
                                className="bs5 btn btn-outline-secondary btn-number br-0">
                                <span className="fa quantity-picker-minus" />
                            </button>
                        </span>
                        <input type="text" className="form-control input-number bg-white"
                            placeholder={QtyMult ? QtyMult : 0}
                            value={tempQuantity}
                            onChange={(e) => {
                                let n = parseInt(e.target.value);
                                if (!isNumber(n)) {
                                    n = false;
                                }
                                if (n !== false) {
                                    manageTempQuantity(n)
                                }
                            }}
                        />
                        <span className="bs5 input-group-append flex-nowrap">
                            <button type="button"
                                onClick={async () => {
                                    await setQuantityWithAction(Plus);
                                }}
                                className="bs5 btn btn-outline-secondary btn-number bl-0">
                                <span className="fa quantity-picker-plus" />
                            </button>
                        </span>
                    </div>
                </div>
                <div className="text-start small-text light light-text collapse_minmax">
                    <span className='min-mult-labal'>Min:</span>{get_quantity_format(QtyMin)} &nbsp;
                    <span className='min-mult-labal'>Mult:</span>{get_quantity_format(QtyMult)} &nbsp;
                </div>

            </div>
        </>
    );
}

export default PlusMinusInputWithDebounceRFQ;